import ControlledField from '../common/ControlledField'
import FormFieldType from '../../enums/form-field.enum'
import { Control, FieldValues } from 'react-hook-form'

interface IProps {
  control: Control<FieldValues, object> | undefined
}

const PlaceForm = ({ control }: IProps) => {
  return (
    <div className="flex flex-col gap-2">
      <ControlledField
        name="name"
        label="Nom"
        control={control}
        rules={{ required: 'Ce champ est requis' }}
        type={FormFieldType.TEXT}
      />
      <ControlledField
        type={FormFieldType.POSITION}
        name="location"
        label="Position"
        control={control}
        rules={{ required: 'Ce champ est requis' }}
      />

      <ControlledField
        type={FormFieldType.LONG_TEXT}
        name="description"
        label="Description"
        control={control}
        rules={{ required: 'Ce champ est requis' }}
      />
      <ControlledField
        type={FormFieldType.IMAGE}
        name="photo"
        label="Photo"
        control={control}
        rules={{ required: 'Ce champ est requis' }}
      />
      <ControlledField
        type={FormFieldType.MULTI_TEXT}
        name="tags"
        label="Tags"
        control={control}
        rules={{ required: 'Ce champ est requis' }}
        placeholder={"Nouveau tag"}
      />
    </div>
  )
}

export default PlaceForm
